<div class="d-flex justify-content-center align-items-center" ngbDropdown>
  <button class="btn btn-sm rounded-3 gap-2 border-0 btn-light d-flex justify-content-center align-items-center" ngbDropdownToggle type="button">
        <span class="material-symbols-outlined" style="font-size: 1.2rem;">
          calendar_today
        </span>
    <span>{{start_at ? moment(start_at).format(dateFormats.ddMMyyyy) : ''}}{{end_at ? ' → ' + moment(end_at).format(dateFormats.ddMMyyyy) : ''}}</span>
  </button>
  <div class="p-3" ngbDropdownMenu>
    <div class="form-floating mb-3">
      <input (change)="handleCustomRange()" [(ngModel)]="start_at" class="form-control" name="startDate" placeholder="Fecha de inicio" type="date">
      <label>Desde</label>
    </div>
    <div class="form-floating">
      <input (change)="handleCustomRange()" [(ngModel)]="end_at" class="form-control" name="startDate" placeholder="Fecha de fin" type="date">
      <label>Hasta</label>
    </div>
  </div>
</div>
